import Vue from "vue";
import Router from "vue-router";
import OfferList from "./views/OfferList.vue";
import OfferUpload from "./views/OfferUpload.vue";
import OfferEditor from "./views/OfferEditor.vue";
import OfferCreate from "./views/OfferCreate.vue";
//import OfferCreateDebug from './views/OfferCreateDebug.vue'
import OfferView from "./views/OfferView.vue";
import Login from "./views/Login.vue";
import Logout from "./views/Logout.vue";
import NotFound from "./views/NotFound.vue";
import Register from "./views/Register.vue";
import Activate from "./views/Activate.vue";
import ResetPassword from "./views/ResetPassword";
import Auth from "./misc/Auth.js";
import OfferPartial from "./views/OfferPartial.vue";
import store from "./store/index.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/admin/offer-list",
    },
    {
      path: "*",
      component: NotFound,
    },
    {
      path: "/admin",
      redirect: "/admin/offer-list",
    },
    {
      path: "/admin/offer-list",
      name: "OfferList",
      component: OfferList,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/offer-upload",
      name: "OfferUpload",
      component: OfferUpload,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/offer-edit/:offerHash",
      name: "OfferEditor",
      component: OfferEditor,
      meta: {
        requiresAuth: true,
      },
    },
    {
      //@todo: i guess that was meant to be to edit certain sections only, not sure any more what this was good for ... maybe for integration of tiny-mce into combit
      path: "/admin/offer-edit/:offerHash/:section",
      name: "OfferPartial",
      component: OfferPartial,
      meta: {
        requiresAuth: true,
        layout: "partial",
      },
    },
    {
      path: "/admin/offer-create",
      name: "OfferCreate",
      component: OfferCreate,
      meta: {
        requiresAuth: true,
      },
    },
    // {
    //   path: '/admin/offer-create-debug',
    //   name: 'OfferCreateDebug',
    //   component: OfferCreateDebug,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: "/admin/offer-copy/:vcId",
      name: "OfferCopy",
      component: OfferCreate,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/register",
      name: "register",
      component: Register,
    },
    {
      path: "/activate/:activationToken",
      name: "activate",
      component: Activate,
    },
    {
      path: "/admin/login",
      name: "Login",
      component: Login,
      props: true,
    },
    {
      path: "/offer/:offerHash",
      name: "OfferView",
      component: OfferView,
    },
    {
      path: "/404/:offerHash",
      name: "404",
      component: NotFound,
    },
    {
      path: "/admin/logout",
      name: "Logout",
      component: Logout,
    },
    {
      path: "/admin/reset-password/:email",
      name: "ResetPassword",
      component: ResetPassword,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && to.meta.requiresAuth === true) {
    if (Auth.isLoggedIn()) {
      next();
    } else {
      store.commit("setTargetUrl", to.fullPath);
      store.commit("setTargetHash", to.hash);
      // next({path: '/admin/login', hash:to.hash, name: 'Login', params: {
      //   redirect: to.fullPath
      // }});
    }
  }
  next();
});

Auth.on("auth_expired", () => {
  router.push("/admin/login");
});

export default router;
